import type { BenchmarkCreativesResult } from '../models/benchmarkCreatives.types'

import { record } from './reportContext'

/**
 * Backend compatibility boundary for `.../metadata/creative-ai/creatives/`. Contract 23
 * §BE-23-15 has not locked this DTO; a malformed or missing `creatives` array degrades to a
 * confident zero rather than throwing.
 */
export function decodeBenchmarkCreativesResponse(value: unknown): BenchmarkCreativesResult {
  const source = record(value)
  const creatives = Array.isArray(source?.creatives) ? source.creatives : []
  const creativeIds = creatives.flatMap((entry) => {
    const id = record(entry)?.creative_id
    return typeof id === 'string' || typeof id === 'number' ? [String(id)] : []
  })
  return { count: creativeIds.length, creativeIds }
}
